// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2-jkD","modalFooterButton":"ModalNotes_modalFooterButton__rrhv-"};